import React, { Component } from 'react';
import { renderRoutes } from '../lib/react-router-config';
import { withRouter } from 'react-router-dom';
import DocumentMeta from 'react-document-meta';
import StyleSheet from 'stilr';
import {
  portable,
  desk,
  getBreakpoints,
  findBreakpoints,
  optimizedResize
} from 'react-flexr';
import TopNav from './common/top-nav';
import Footer from './common/footer';
import { firstLetterUpperCase } from './utils/firstLetterUppercase';

const BASE = __DEV__ ? undefined : 'https://www.sparpenge.dk';

const styles = StyleSheet.create({
  container: {
    paddingBottom: 225,
    [portable]: {
      paddingBottom: 'initial'
    }
  },
  contentContainer: {
    marginBottom: 11,
    [desk]: {
      paddingTop: 11
    }
  }
});


function fixCanonical(text) {
  const fixed = text
      .toLowerCase()
      .replace('æ', 'ae')
      .replace('ø', 'oe')
      .replace('å', 'aa')
      .replace(/[^-a-z0-9/]/g, '');

  return fixed;
}

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      breakpoints: 'desk'
    };
  }

  componentDidMount() {
    this.setState({ breakpoints: getBreakpoints() });

    optimizedResize.init(() => {
      const breakpoints = findBreakpoints();
      if (breakpoints) {
        this.setState({ breakpoints: breakpoints.join() });
      }
    });
  }

  render() {
    const { route } = this.props;
    return (
      <DocumentMeta
        title={title => (title ? `${firstLetterUpperCase(title)} - SparPenge.dk` : 'SparPenge.dk')}
        canonical={path => encodeURI(`${BASE || ''}${fixCanonical(this.props.location.pathname || path)}`)}
        // base={BASE}
        extend
      >
        {/feed_only=true/.test(this.props.location.search) || this.props.feed ? (
        <div className={`container ${styles.contentContainer}`}>
          {renderRoutes(route.routes)}
        </div>) : (
        <div className={`fs ${styles.container}`}>
          {<TopNav />}

          <div className={`container ${styles.contentContainer}`}>
            {renderRoutes(route.routes)}
          </div>

          <Footer />
        </div>)}
      </DocumentMeta>
    );
  }
}

export default withRouter(App);
